// extracted by mini-css-extract-plugin
export default {"h3":"H3_h3__duTTf"};